import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Zap, MessageSquare, Settings, Keyboard } from 'lucide-react';
const features = [{
  icon: <Zap className="w-6 h-6 text-whatsapp" data-id="element-90" />,
  title: 'Botón de Pánico IA',
  description: 'El prompt exacto para calmar clientes furiosos en 30 segundos.'
}, {
  icon: <MessageSquare className="w-6 h-6 text-whatsapp" data-id="element-91" />,
  title: '15 Plantillas de Rescate',
  description: 'Mensajes listos para ventas, retrasos, pagos y citas.'
}, {
  icon: <Settings className="w-6 h-6 text-whatsapp" data-id="element-92" />,
  title: 'Mapa de Automatización',
  description: 'Setup de 10 minutos para que tu negocio funcione sin ti.'
}, {
  icon: <Keyboard className="w-6 h-6 text-whatsapp" data-id="element-93" />,
  title: 'Atajos de Teclado Profetas',
  description: 'Responde preguntas frecuentes en 1 segundo.'
}];
export function Solution() {
  return <section className="py-24 px-4 bg-dark-card border-t border-dark-border relative" data-id="element-94">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[500px] bg-whatsapp/5 blur-[120px] pointer-events-none" data-id="element-95" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-96">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-97">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-98">
            La Solución:{' '}
            <span className="text-whatsapp" data-id="element-99">El Business-Rescue Kit</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto" data-id="element-100">
            No es un curso aburrido de 20 horas. Es un{' '}
            <strong className="text-white" data-id="element-101">Panel de Control Interactivo</strong>{' '}
            diseñado para dueños de negocios ocupados (Logística, Servicios,
            Ventas) que necesitan soluciones{' '}
            <span className="text-whatsapp font-bold" data-id="element-102">AHORA</span>.
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-103">
          <div className="grid grid-cols-2 gap-4" data-id="element-104">
            <motion.img initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} src="https://cdn.magicpatterns.com/uploads/wV54ixwRLZ5Ai1qDb3fLWt/KIT_RESCUE_2.1.jpg" alt="Hombre relajado usando el dashboard" className="w-full h-72 object-cover rounded-2xl border border-whatsapp/20 shadow-[0_0_30px_rgba(37,211,102,0.1)]" data-id="element-105" />
            <motion.img initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} src="https://cdn.magicpatterns.com/uploads/jDaUiE2URmT3VqkT2Ntba6/KIT_MUJER_0_STRESS_2.jpg" alt="Mujer relajada usando el dashboard" className="w-full h-72 object-cover rounded-2xl border border-whatsapp/20 shadow-[0_0_30px_rgba(37,211,102,0.1)] mt-12" data-id="element-106" />
          </div>

          <div data-id="element-107">
            <h3 className="text-2xl font-bold mb-8" data-id="element-108">
              Lo que vas a recibir hoy:
            </h3>
            <div className="space-y-6" data-id="element-109">
              {features.map((feature, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex gap-4 p-5 bg-dark-lighter rounded-xl border border-dark-border hover:border-whatsapp/30 transition-colors" data-id="element-110">
                  <div className="shrink-0 mt-1 bg-whatsapp/10 p-2 rounded-lg" data-id="element-111">
                    {feature.icon}
                  </div>
                  <div data-id="element-112">
                    <h4 className="text-lg font-bold text-white mb-1 flex items-center gap-2" data-id="element-113">
                      {feature.title}
                      <CheckCircle2 className="w-4 h-4 text-whatsapp" data-id="element-114" />
                    </h4>
                    <p className="text-gray-400" data-id="element-115">{feature.description}</p>
                  </div>
                </motion.div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}